import apiService from "./api";

const menuService = {
  // Menu operations
  getMenus(params) {
    return apiService.get("/menus", params);
  },
  getMenuById(id, includeMeals = true) {
    return apiService.get(`/menus/${id}`, { meals: includeMeals });
  },
  createMenu(data) {
    return apiService.post("/menus", data);
  },
  updateMenu(id, data) {
    return apiService.put(`/menus/${id}`, data);
  },
  deleteMenu(id) {
    return apiService.delete(`/menus/${id}`);
  },
  getMenuByDateAndType(date, type) {
    return apiService.get("/menus", { from: date, to: date, type: type });
  },
  getWebAppMenu(params) {
    return apiService.get("/menus/web-app", params);
  },
  getWebAppOnlyMenu(fromDate, toDate) {
    return apiService.get("/menus/web-app-only-menu", {
      from: fromDate,
      to: toDate,
    });
  },
  getCloneableMenus(data) {
    // Corresponds to /menus/get-clone-menu
    return apiService.post("/menus/get-clone-menu", data);
  },

  // Meal operations
  setOrderMeal(mealItem) {
    return apiService.post("/meals/set-order-meal", mealItem);
  },
  deleteCloneMeal(mealItem) {
    return apiService.post("/meals/delete-clone", mealItem);
  },
  changeReservedMeal(payload) {
    return apiService.post("/meals/v2/change-reserved-meal", payload);
  },

  // Food operations
  getFoods() {
    return apiService.get("/foods");
  },

  // Menu Type operations
  getMenuTypes() {
    return apiService.get("/menus/menu-types");
  },
  createMenuType(data) {
    return apiService.post("/menus/menu-types", data);
  },
  updateMenuType(id, data) {
    return apiService.put(`/menus/menu-types/${id}`, data);
  },
  deleteMenuType(id) {
    return apiService.delete(`/menus/menu-types/${id}`);
  },

  // Menu Type Image operations
  deleteMenuTypeImage(id) {
    return apiService.delete(`/menus/menu-types/${id}/image`);
  },

  // Gallery operations
  getGalleryImages() {
    return apiService.get("/gallery");
  },
  uploadMenuTypeImage(formData) {
    return apiService.post("/gallery", formData);
  },

  // Guest menu operations
  getGuestWebAppMenu(params) {
    return apiService.get("/guest-web-app", params);
  },
  getMobAppMenu() {
    return apiService.get("/menus/mob-app");
  },
  // Get menu for current date
  getMenuForCurrentDate(data) {
    return apiService.post("/menus/get-menu-for-current-date", data);
  },
};

export default menuService;
